const LUCENE_OPERATORS = /\b(AND|OR|NOT)\b/;

export function formatLuceneQuery(raw: string): string {
    const trimmed = raw.trim();
    if (!trimmed) return '';

    const tokens = tokenize(trimmed);
    return buildFormatted(tokens);
}

type Token =
    | {type: 'OPEN_PAREN'}
    | {type: 'CLOSE_PAREN'}
    | {type: 'OPERATOR'; value: string}
    | {type: 'TEXT'; value: string};

function tokenize(input: string): Token[] {
    const tokens: Token[] = [];
    let i = 0;

    while (i < input.length) {
        const ch = input[i];

        if (/\s/.test(ch)) {
            i++;
            continue;
        }

        if (ch === '(') {
            tokens.push({type: 'OPEN_PAREN'});
            i++;
            continue;
        }

        if (ch === ')') {
            tokens.push({type: 'CLOSE_PAREN'});
            i++;
            continue;
        }

        if (ch === '"') {
            const end = input.indexOf('"', i + 1);
            if (end === -1) {
                tokens.push({type: 'TEXT', value: input.slice(i)});
                break;
            }
            tokens.push({type: 'TEXT', value: input.slice(i, end + 1)});
            i = end + 1;
            continue;
        }

        let word = '';
        while (i < input.length && !/[\s()"']/.test(input[i])) {
            word += input[i];
            i++;
        }

        if (LUCENE_OPERATORS.test(word) && word === word.toUpperCase()) {
            tokens.push({type: 'OPERATOR', value: word});
        } else {
            tokens.push({type: 'TEXT', value: word});
        }
    }

    return tokens;
}

function buildFormatted(tokens: Token[]): string {
    const lines: string[] = [];
    let depth = 0;
    let currentLine = '';

    const indent = () => '  '.repeat(depth);

    const flushLine = () => {
        const trimmedLine = currentLine.trim();
        if (trimmedLine) {
            lines.push(indent() + trimmedLine);
        }
        currentLine = '';
    };

    for (let i = 0; i < tokens.length; i++) {
        const token = tokens[i];

        switch (token.type) {
            case 'OPEN_PAREN':
                if (currentLine.trim()) {
                    currentLine += '(';
                } else {
                    currentLine += '(';
                }
                flushLine();
                depth++;
                break;

            case 'CLOSE_PAREN':
                flushLine();
                depth = Math.max(0, depth - 1);
                currentLine = ')';
                flushLine();
                break;

            case 'OPERATOR':
                flushLine();
                currentLine = token.value + ' ';
                break;

            case 'TEXT': {
                const nextColon = tokens[i + 1];
                if (currentLine.trim()) {
                    currentLine += token.value;
                } else {
                    currentLine += token.value;
                }

                if (nextColon && nextColon.type !== 'OPERATOR' && nextColon.type !== 'CLOSE_PAREN' && nextColon.type !== 'OPEN_PAREN') {
                    currentLine += ' ';
                } else if (nextColon && nextColon.type === 'OPEN_PAREN') {
                    currentLine += ' ';
                }
                break;
            }
        }
    }

    flushLine();
    return lines.join('\n');
}
